import React from 'react';

export const onEnterAdapter = (func: () => unknown) => {
  return (event: React.KeyboardEvent) => {
    const {
      nativeEvent: { key },
    } = event;
    if (key === 'Enter') {
      func();
    }
  };
};
